/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminStockAdjustResVo } from './AdminStockAdjustResVo';
import {
    AdminStockAdjustResVoFromJSON,
    AdminStockAdjustResVoFromJSONTyped,
    AdminStockAdjustResVoToJSON,
    AdminStockAdjustResVoToJSONTyped,
} from './AdminStockAdjustResVo';

/**
 * 
 * @export
 * @interface ResponseAdminStockAdjustResVo
 */
export interface ResponseAdminStockAdjustResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseAdminStockAdjustResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseAdminStockAdjustResVo
     */
    message?: string;
    /**
     * 
     * @type {AdminStockAdjustResVo}
     * @memberof ResponseAdminStockAdjustResVo
     */
    data?: AdminStockAdjustResVo;
}

/**
 * Check if a given object implements the ResponseAdminStockAdjustResVo interface.
 */
export function instanceOfResponseAdminStockAdjustResVo(value: object): value is ResponseAdminStockAdjustResVo {
    return true;
}

export function ResponseAdminStockAdjustResVoFromJSON(json: any): ResponseAdminStockAdjustResVo {
    return ResponseAdminStockAdjustResVoFromJSONTyped(json, false);
}

export function ResponseAdminStockAdjustResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAdminStockAdjustResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AdminStockAdjustResVoFromJSON(json['data']),
    };
}

export function ResponseAdminStockAdjustResVoToJSON(json: any): ResponseAdminStockAdjustResVo {
    return ResponseAdminStockAdjustResVoToJSONTyped(json, false);
}

export function ResponseAdminStockAdjustResVoToJSONTyped(value?: ResponseAdminStockAdjustResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': AdminStockAdjustResVoToJSON(value['data']),
    };
}

